// extracted by mini-css-extract-plugin
module.exports = {"auditTable":"Audit_auditTable__1fY3U","audit":"Audit_audit__1_dVT"};